import Plyr from "../../node_modules/plyr/dist/plyr.min.mjs";

let players = [];

export default {
    init: function () {
        document.querySelectorAll(".plyr-video").forEach((player_el) => {
            const player = new Plyr(player_el);
            players = [...players, player];
        });
    },
    cleanup: function () {
        players.forEach((player) => {
            player.destroy();
        });
        players = [];
    }
};
